import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminDashboard from './AdminDashboard';
import PrinterManagement from './Printers/PrinterManagement';
import MaterialManagement from './Materials/MaterialManagement';
import AssociationManagement from './Associations/AssociationManagement';
import PrintedProductManagement from './PrintedProducts/PrintedProductManagement';

const AdminRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminDashboard />} />
      <Route path="/dashboard" element={<AdminDashboard />} />
      <Route path="/printers" element={<PrinterManagement />} />
      <Route path="/materials" element={<MaterialManagement />} />
      <Route path="/associations" element={<AssociationManagement />} />
      <Route path="/printed-products" element={<PrintedProductManagement />} />
    </Routes>
  );
};

export default AdminRoutes;
